/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      const currentPage = parseInt(new URLSearchParams(document.location.search).get('page') || '1', 10);
      this.i = currentPage + 1;
      this.has_more_pages = this.dataset.hasNext === 'true';
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore') && this.button) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
      if (!this.classList.contains('pagination-type--paginated')) {
        this.fillIncompleteRow();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function(event) {
        event.preventDefault();
        base.loadProducts();
        this.blur();
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function(entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading') || base.has_more_pages === false) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      return fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        })
        .catch(() => {
          base.removeAttribute('loading');
        });
    }
    getDesktopColumns() {
      if (!this.grid) {
        return 0;
      }
      for (let i = 0; i < this.grid.classList.length; i++) {
        const match = this.grid.classList[i].match(/^medium-up-(\d+)$/);
        if (match) {
          return parseInt(match[1], 10);
        }
      }
      return 0;
    }
    getVisibleCardsCount() {
      if (!this.grid) {
        return 0;
      }
      return this.grid.querySelectorAll(':scope > li.column').length;
    }
    getMinimumVisibleCardsCount() {
      if (!this.grid) {
        return 0;
      }
      return parseInt(this.grid.dataset.minVisibleProducts || '0', 10) || 0;
    }
    getRenderedProductHandles() {
      if (!this.grid) {
        return new Set();
      }
      return new Set(
        Array.from(this.grid.querySelectorAll(':scope > li[data-product-handle]'))
          .map(card => card.dataset.productHandle)
          .filter(Boolean)
      );
    }
    fillIncompleteRow() {
      if (!this.grid || this.has_more_pages === false || this.getAttribute('loading')) {
        return;
      }
      const columns = this.getDesktopColumns();
      if (!columns) {
        return;
      }
      const visibleCards = this.getVisibleCardsCount();
      const remainder = visibleCards % columns;
      const minimumVisibleCards = this.getMinimumVisibleCardsCount();
      if ((minimumVisibleCards && visibleCards < minimumVisibleCards) || remainder !== 0) {
        this.loadProducts();
      }
    }
    renderProducts(html, url) {
      let base = this,
        parsed = new DOMParser().parseFromString(html, 'text/html'),
        grid_to_replace = parsed.getElementById('product-grid');

      if (!grid_to_replace) {
        base.has_more_pages = false;
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
      const parsedPagination = parsed.querySelector(
        'pagination-theme[data-section="' + base.dataset.section + '"]'
      );
      base.has_more_pages = parsedPagination && parsedPagination.dataset.hasNext === 'true';
      const parsedButton = parsedPagination && parsedPagination.querySelector('.load-more');
      if (base.button && parsedButton) {
        base.button.href = parsedButton.href;
      }
      if (!base.has_more_pages) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
      }
      let products = Array.from(grid_to_replace.querySelectorAll('.column')),
        renderedProductHandles = base.getRenderedProductHandles(),
        appendedProducts = [];

      for (var i = 0; i < products.length; i++) {
        const productHandle = products[i].dataset.productHandle;
        if (productHandle && renderedProductHandles.has(productHandle)) {
          continue;
        }
        if (productHandle) {
          renderedProductHandles.add(productHandle);
        }
        this.grid.appendChild(products[i]);
        appendedProducts.push(products[i]);
      }
      if (!appendedProducts.length) {
        base.removeAttribute('loading');
        if (base.has_more_pages) {
          base.loadProducts();
        }
        return;
      }
      if (this.animations_enabled) {
        gsap.set(appendedProducts, {
          opacity: 0,
          y: 30
        });
        gsap.to(appendedProducts, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function() {
            base.removeAttribute('loading');
            base.fillIncompleteRow();
          }
        });
      } else {
        base.removeAttribute('loading');
        base.fillIncompleteRow();
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
